export const PRIMARY_COLOR = "#0B142233"
export const BLACK_COLOR = "#0b1422"
export const WHITE_COLOR = ""
